import { TransportModeHelper } from '../../../../../../../helpers/transport-mode.helper';
import { TransportMode } from '../../../../../../../models/transport-mode.enum';
import { TranslationService } from '../../../../../../../services/translation.service';

export default class LabelHelper {
  public static createIconHtml(
    transportMode: TransportMode,
    timeString: string | undefined,
    line: { name: string; foregroundColor: string; backgroundColor: string } | undefined,
    isCancelled: boolean
  ): string {
    if (!transportMode && !line && !timeString) return '';

    let result = '<div class="bg-white rounded d-flex align-items-center small" style="padding: 0.125rem 0.25rem">';

    if (line) {
      result += `<span class="visually-hidden">${transportMode === TransportMode.train ? TranslationService.get('common.trainnumber') : TranslationService.get('common.line')}</span>`;
      result += `<span class="fw-bold text-center rounded border text-nowrap ${LabelHelper.getLineLabelBorderClass(line.backgroundColor)}"
      style="min-width: 1.5rem; padding: 0 0.125rem; ${LabelHelper.getLineLabelColorStyle(line)}">
        ${line.name}
      </span>`;
    }

    const transportModeIconSource = LabelHelper.getTransportModeIconSource(transportMode);
    if (transportModeIconSource) {
      result += `<img
            src="${transportModeIconSource}"
            alt="${TransportModeHelper.translate(transportMode)}"
            class="me-1"
            style="height:1.5rem"
        />`;
    }

    if (timeString && !isCancelled) {
      result += `<span class="fw-bold">${timeString}</span>`;
    }

    if (timeString && isCancelled) {
      result += `<span class="fw-bold text-danger me-1 text-line-through">${timeString}</span>`;
      result += `<span class="fw-bold text-danger">${TranslationService.get('common.cancelled')}</span>`;
    }

    result += '</div>';

    return result;
  }

  private static getLineLabelBorderClass(backgroundColor: string): string {
    if (!backgroundColor) return '';
    return backgroundColor?.toLowerCase() === '#ffffff' ? 'border-gray' : 'border-transparent';
  }

  private static getLineLabelColorStyle(line: { name: string; foregroundColor: string; backgroundColor: string }): string {
    if (!line) return '';
    return `color: ${line.foregroundColor}; background-color: ${line.backgroundColor};`;
  }

  private static getTransportModeIconSource(transportMode: TransportMode): string {
    // The svgs are placed in the wwwroot/icons folder (i.e. not copied by vite from the assets folder at build time)
    if (transportMode === TransportMode.train) {
      return '/icons/train-dark.svg';
    }
    if (transportMode === TransportMode.bus) {
      return '/icons/bus-dark.svg';
    }
    if (transportMode === TransportMode.tram) {
      return '/icons/tram-dark.svg';
    }
    if (transportMode === TransportMode.ferry) {
      return '/icons/ferry-dark.svg';
    }
    if (transportMode === TransportMode.walk) {
      return '/icons/walk-dark.svg';
    }
    if (transportMode === TransportMode.bike) {
      return '/icons/bike-dark.svg';
    }
    if (transportMode === TransportMode.car) {
      return '/icons/car-dark.svg';
    }
    if (transportMode === TransportMode.bussondemand) {
      return '/icons/buss-on-demand-dark.svg';
    }
    return '';
  }
}
